import * as moment from "moment";
import Data from "source/app/services/Data";
import { IUserDTO } from "../../../../../../../../motw_core/DTOs/IUserDTO";
import { WithAnimatedProgressBarAsync } from "../../../ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { ISyncNotificationState } from "../ISyncNotificationState";

export async function SynchronizeAsync(state: ISyncNotificationState) {
    if (!state.userDto) {
        return;
    }

    const lastModifiedTime = moment(state.userDto.lastWrite.lastmodifiedtime)
        .utcOffset(0)
        .format();

    const syncDifference = moment(state.lastLoadAllTime)
        .utcOffset(0)
        .diff(lastModifiedTime, "milliseconds");

    const isOutOfSync = syncDifference < 0;

    if (isOutOfSync) {
        console.log(
            `syncDifference is ${syncDifference}ms. synchronization started...`
        );

        await WithAnimatedProgressBarAsync(() => Data.Load.AllAsync());
        console.log(`synchronization complete.`);
    }
}
